export default __webpack_public_path__ + "static/companies-three-7cd5a2fd8b4aa0a7c70029926d131ff3.jpg";